import { AES_PASS } from "config/envConfig";
import CryptoJS from "crypto-js";
class Services {
  get_decrypted(encrypted) {
    // Encrypt
    return CryptoJS.AES.decrypt(encrypted, AES_PASS).toString(CryptoJS.enc.Utf8);
  }
}
export default Services;
